/** @format */

/* eslint react-hooks/rules-of-hooks: "warn", @typescript-eslint/prefer-nullish-coalescing: "warn" */
import React, { useContext } from 'react';

import { StockAlertPageType } from '@toucan/types/product';

import {
    CreateAlert,
    CreateAlertModel,
} from '@toucan/components/organisms/create-alert';

import {
    ApplicationContext,
    ModalSize,
} from '@toucan/client/global/application';

export function alertHelper(
    baseModel?: CreateAlertModel,
    pageType?: StockAlertPageType
) {
    const { setModalContent, setModalVisible, setModalSize } =
        useContext(ApplicationContext);

    /**
     * Handles opening the modal when the
     * 'Create an alert' button is clicked
     *
     * @param {Model} model the model data
     */
    function handleOpenCreateAlertModal(model?: CreateAlertModel): void {
        const alertModel = model || baseModel;

        if (!alertModel) {
            return;
        }

        setModalContent(
            <CreateAlert
                model={alertModel}
                onClose={() => {
                    setModalVisible(false);
                }}
                pageType={pageType}
            />
        );
        setModalSize(ModalSize.LARGE);
        setModalVisible(true);
    }

    return {
        handleOpenCreateAlertModal,
    };
}
